import { keywordGroupsQueryClient } from "app/services/keyword-groups";

import { WidgetExporter } from "./WidgetExporter";

export class KeywordAnalysisShareOverTimeExporter extends WidgetExporter {
    constructor($window, widget, _$widgetElement, $q, $timeout, chosenSites, $filter, exportOptions, utility) {
        super($window, widget, _$widgetElement, $q, $timeout, chosenSites, $filter, exportOptions, utility);
    }

    protected async getTitleHTML() {
        const { viewData } = this.widget;
        const duration = viewData.duration;
        const country = viewData.country.text;
        let { keys: keyword } = this.widget.apiParams;

        const group = await keywordGroupsQueryClient.getGroupById(keyword);
        if (group) {
            keyword = `Group '${group.Name}'`;
        } else {
            keyword = `Keyword '${keyword}'`;
        }
        const context = this.widget.context.split(".")[1];
        let source;
        switch (context) {
            case "total":
                source = "Total traffic";
                break;
            case "organic":
                source = "Organic Only";
                break;
            case "paid":
                source = "Paid Only";
                break;
            case "mobileweb":
                source = "Mobile Web Only";
                break;
        }
        return this.$q
            .resolve(`<div style="padding: 21px 24px; margin-bottom: 12px; border-bottom: 1px solid #e4e4e4; color: #2b3d52; font-family: 'Roboto', Tahoma, sans-serif;">
                        <span style="font-size: 35px;">${viewData.title}</span>
                        <span style="font-size: 18px; padding-left: 24px;">${duration} | ${country} | ${source} | ${keyword}</span>
                    </div>`);
    }
}
